goog.provide('el8.app.shared.dialog.collectCancelReason');

goog.require('el8.template.app.shared.dialog.collectReason');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');


el8.app.shared.dialog.collectCancelReason = (function() {
    var saveCb = null;
    var cancelCb = null;
    var validateFn = null;
    var DEFAULT_TITLE = 'Cancel Order';

    var that = new el8.uiwidget.FormDialog({
        title: DEFAULT_TITLE,
        autoHeight: true,
        width: 400,
        modal: true,
        contentFn: function() {
            return el8.template.app.shared.dialog.collectReason.content({});
        }
    });

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'reason',
                selector: ':input[name="reason"]',
                infoText: 'Enter reason...'
            }
        ]
    });

    form.addButton('save', 'Mark Canceled', function(_form) {
        if (saveCb) {
            saveCb({
                reason: form.getVal('reason')
            });
            el8.util.amplitude.logUpdateStatusCanceled('Mark Canceled',Boolean(form.getVal('reason')));
        }
        that.hide();
    }, true);

    form.addDiscardChangesButton(function() {
        if (cancelCb) { cancelCb(); }
        el8.util.amplitude.logUpdateStatusCanceled('Discard');
        that.hide();
    });

    that.setForm(form);

    var super_show = that.show;
    that.show = function(opts) {

        opts = opts || {};
        super_show.call(that);
        cancelCb = opts.cancelCallbackFn || null;
        saveCb = opts.saveCallbackFn || null;
        validateFn = opts.validateFn || null;
    };

    var super_hide = that.hide;
    that.hide = function() {
        cancelCb = null;
        saveCb = null;
        validateFn = null;
        that.setTitle(DEFAULT_TITLE);
        super_hide.call(that);
    };

    return that;

})();
